
import { useNavigate } from "react-router-dom";
import { IconButton, Pagination, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { bloquearUserService } from "../../../../services";
import { TooltipAndIcon } from "../../components/TooltipAndIcon";
import { AlertScreen } from "../../components/AlertScreen";


import Swal from "sweetalert2";





export const TablaListadoUsuarios = ({ data, page, chagePage }) => {


    const navigate = useNavigate();
    const queryClient = useQueryClient();


    const actualizarUsuario = ( user ) => {
        navigate(`/admin/user/${user.id}/edit`);
    }



    const eliminarUsuario = (user) => {
        Swal.fire({
            title: `¿${user.activo ? 'Bloquear' : 'Desbloquear'} Usuario?`,
            text: `Esta seguro de ${user.activo ? 'Bloquear' : 'Desbloquear'} a: ${ user.nombre }`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si, ${user.activo ? 'Bloquear' : 'Desbloquear'}` 
        }).then( async( result ) => {
            if(result.value){
                const resp = await bloquearUserService( user.id );
                if( resp ){
                    Swal.fire('Exitoso', `Usuario ${user.activo ? 'Bloqueado' : 'Desbloqueado'}`, 'success');
                    queryClient.invalidateQueries('usuarios-rol');
                }
            }
        });
    }


    return (
        <>
        {(data.length > 0) 
        ?   <Paper sx={{ width: '100%', maxWidth: {xs:450, sm:800, md:'100%'}, overflowX: 'auto', mt: 4 }}>
                <TableContainer sx={{ maxWidth:'100%' }}>
                    <Table sx={{ minWidth: 700 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'5%'}}>A.</TableCell>
                                <TableCell sx={{width:'30%'}}>NOMBRE</TableCell>
                                <TableCell sx={{width:'20%'}}>EMAIL</TableCell>
                                <TableCell sx={{width:'15%'}}>MOVIL</TableCell>
                                <TableCell sx={{width:'15%'}}>ROLE</TableCell>
                                <TableCell sx={{width:'15%'}}>OPCIONES</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {data.map((user) => (
                            <TableRow  key={ user.id}>
                                <TableCell >
                                    {(user.activo)
                                    ?   <IconButton className='boton-estado trru'/>
                                    :   <IconButton className='boton-estado fall'/>
                                    }
                                </TableCell>
                                <TableCell>{ user.nombre }</TableCell>   
                                <TableCell>{ user.email }</TableCell>
                                <TableCell>{ user.movil }</TableCell>
                                <TableCell>{ user.role }</TableCell>
    
                                <TableCell>
                                    <TooltipAndIcon
                                        titulo='Editar Usuario'
                                        icono='setting'
                                        onClick={ () => actualizarUsuario(user) }
                                    />
                                    <TooltipAndIcon
                                        titulo='Eliminar Usuario'
                                        icono='eliminar'
                                        onClick={ () => eliminarUsuario(user) }
                                        color='red'
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>

                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(50 / 50)} disabled={Math.ceil(50 / 50) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
                </TableContainer>
            </Paper>

        :   <AlertScreen title="No hay usuarios creados por el momento..."/>
        }
        </>
    )



}
